import { RiskDescriptionsType, MetaType } from 'store/modules/Meta/types';
import StoreHelpers, { store } from 'store/store';
import MixTable from 'assets/images/morningstar_mix_table.png';
import morningstarMixTable from 'assets/images/morningstar_mix_table.png';

export const getRiskDescription = (riskLevel: number) => {
  if (!riskLevel) return;
  const state = store.getState();
  const riskDescriptions =
    StoreHelpers.selectors.metaSelectors.riskDescriptions(state);
  const riskLevels = StoreHelpers.selectors.metaSelectors.riskLevels(state);
  const filteredRiskLevels = riskLevels.filter(
    (risk: MetaType) => Number(risk.value) === riskLevel
  );

  const filteredRiskDescriptions = riskDescriptions.filter(
    (risk: RiskDescriptionsType) => risk.risk_level === riskLevel
  );

  return (
    filteredRiskDescriptions[0] && {
      risk_level: filteredRiskDescriptions[0].risk_level,
      description:
        filteredRiskDescriptions[0].risk_description ||
        filteredRiskDescriptions[0].description,
      risk_name: filteredRiskLevels[0].name
    }
  );
};

export const getRiskDescriptionMorningStar = (data: any, caseInfo: any) => {
  const descriptionParts = [];

  const sanitizeHTML = (html: any) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  // Append sections if the corresponding data is not null
  if (data?.groupOverview) {
    descriptionParts.push(
      `<h3>About your risk group</h3>${sanitizeHTML(data.groupOverview)}`
    );
  }
  if (data?.financialDecisions) {
    const content = [
      `<h3>Making financial decisions</h3>${sanitizeHTML(data.financialDecisions)}`
    ];

    if (caseInfo.questionnaireLength === 10) {
      content.push(
        `<div><img style="margin-top: 4px" src=${morningstarMixTable} alt="Morningstar mix table" /></div>`
      );
    }

    descriptionParts.push(content.join(''));
  }

  if (data?.employmentText) {
    descriptionParts.push(
      `<h3>Employment</h3>${sanitizeHTML(data.employmentText)}`
    );
  }
  if (data?.disappointmentsText) {
    descriptionParts.push(
      `<h3>Financial disappointments</h3>${sanitizeHTML(data.disappointmentsText)}`
    );
  }
  if (data?.financialPastText) {
    descriptionParts.push(
      `<h3>Financial past</h3>${sanitizeHTML(data.financialPastText)}`
    );
  }
  if (data?.govBenefitsText) {
    descriptionParts.push(
      `<h3>Government text and tax advantages</h3>${sanitizeHTML(data.govBenefitsText)}`
    );
  }
  if (data?.investmentText) {
    const content = [`<h3>Investment</h3>${sanitizeHTML(data.investmentText)}`];

    if (caseInfo.questionnaireLength === 25) {
      content.push(
        `<div style="margin-top: 1em;">
          <img src="${MixTable}" style="max-width: 100%; height: auto;" />
        </div>`
      );
    }

    descriptionParts.push(content.join(''));
  }

  // Join all parts with a separator
  const description = descriptionParts.join('');

  return {
    description:
      description || sanitizeHTML(data?.riskTolerancePercentText || ''),
    risk_name: data?.calculatedRiskGroup
  };
};
